//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/TaggedObject.js";
let d=[[],[[[],"GetStatusType",{R_:{status:''}},0,0],[[],"GetMessage",{R_:{statusMessage:''}},0,0]],[]];
SPLM.Mfg.AM.MeshStatus = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.MeshStatus";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mfg.AM.MeshStatus.Type = Object.freeze({
    "Unchecked" : "Unchecked", "Busy" : "Busy", "Error" : "Error", "Warning" : "Warning", "Ok" : "Ok", "Sheet" : "Sheet"});

export default SPLM;